export default __webpack_public_path__ + "static/2-81a2f0f83b02d1c07c35e14f0accee6f.png";